// import DoughnutChart from './DoughnutChart';
import TokenomicsPNG from "../images/graph-tokenomics.png";
import Chart from "./Chart";

export default function Tokenomics() {
  return (
    <section
      id="tokenomics"
      className="token padding-top padding-top padding-bottom shape-fadeBlob--left bg--primary-color"
    >
      <div className="container">
        <div className="section-header section-header--center pb-5">
          <div className="section-header__content">
            <div className="section-header__titlebar text-center">
              <p className="section-header__subtitle"> QTM</p>
              <h2 className="section__header__title">Tokenomics</h2>
            </div>
          </div>
        </div>
        <div className="token__wrapper">
          <div className="row g-5">
            <div className="col-lg-6">
              <div
                className="token__info aos-init"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div><Chart /></div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="token__allocation  bg--shade1 aos-init"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="token__allocation-inner text-center">
                  <h4 className="pb-3">Token Allocation</h4>
                  <ul className="token__info-list">
                    <li className="token__info-list-item">
                      <p className="token__info-list-name">Total Supply</p>
                      <p className="token__info-list-value">1,000,000</p>
                    </li>
                    <li className="token__info-list-item">
                      <p className="token__info-list-name">Rewards</p>
                      <p className="token__info-list-value">25%</p>
                    </li>
                    <li className="token__info-list-item">
                      <p className="token__info-list-name">Staking</p>
                      <p className="token__info-list-value">25%</p>
                    </li>
                    <li className="token__info-list-item">
                      <p className="token__info-list-name">Liquidity</p>
                      <p className="token__info-list-value">50%</p>
                    </li>
                  </ul>
                  <h4 className="pt-5 pb-3">Taxes</h4>
                  <ul className="token__info-list">
                    <li className="token__info-list-item">
                      <p className="token__info-list-name">Buy Taxes</p>
                      <p className="token__info-list-value">1% Liquidity</p>
                    </li>
                    <li className="token__info-list-item">
                      <p className="token__info-list-name">Sell Taxes</p>
                      <p className="token__info-list-value">
                        1% Mktg / Dev
                      </p>
                    </li>
                    {/* <li className="token__info-list-item">
                                        <p className="token__info-list-name">Staking</p>
                                        <p className="token__info-list-value">25%</p>
                                    </li>
                                    <li className="token__info-list-item">
                                        <p className="token__info-list-name">Liquidity</p>
                                        <p className="token__info-list-value">50%</p>
                                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
